import { render } from "./App.vue?vue&type=template&id=2482162c"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./css/tailwind.css?vue&type=style&index=0&lang=css"
script.render = render

export default script